import { Button, Checkbox, FormControlLabel } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Input from '../../../Components/Admin/Input';
import { Address } from '../../../Objects/models/Address';
import Teachr from '../../../Objects/models/Teachr';
import TeachrContact from '../../../Objects/models/TeachrContact';
import TeachrContactRepository from '../../../Repositories/TeachrContactRepository';
import ValidateBIC from '../../../Validation/Bic';
import ValidateIbanAici from '../../../Validation/IbanAici';
import Layout from './Layout';
import Functions from '../../../Helpers/Functions';

const Third = (props: any) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()
    const [teachrContact, setTeachrContact] = useState<TeachrContact>()
    const [teachr, setTeachr] = useState<Teachr>()
    const [address, setAddress] = useState<Address>()
    const [iban, setIban] = useState('')
    const [bic, setBic] = useState('')
    const [terms, setTerms] = useState<boolean>()
    const [cgu, setCgu] = useState<boolean>()
    const [cgv, setCgv] = useState<boolean>()
    const [acceptMarketingEmail, setAcceptMarketingEmail] = useState(false)
    const [isNotify, setIsNotify] = useState(false)
    const [errors, setErrors] = useState({
        iban: false,
        bic: false,
        terms: false,
        cgu: false,
        cgv: false
    })
    useEffect(() => {
        if (terms !== undefined) {
            setErrors({
                iban: errors.iban,
                bic: errors.bic,
                terms: !terms,
                cgu: errors.cgu,
                cgv: errors.cgv
            })  
        }
    }, [terms])
    useEffect(() => {
       if (cgu !== undefined) {
        setErrors({
            iban: errors.iban,
            bic: errors.bic,
            terms: errors.terms,
            cgu: !cgu,
            cgv: errors.cgv
        })
       }
    }, [cgu])
    useEffect(()=>{
       if (cgv !== undefined) {
        setErrors({
            iban: errors.iban,
            bic: errors.bic,
            terms: errors.terms,
            cgu: errors.cgu,
            cgv: !cgv
        })
       }
    },[cgv])
    const validate = (): boolean => {
        let valid = {
            iban: false,
            bic: false,
            terms: false,
            cgu: false,
            cgv: false
        }
        valid.iban = !ValidateIbanAici(iban).isValid
        valid.bic = !ValidateBIC(bic).isValid
        valid.cgu = !cgu
        valid.cgv = !cgv
        valid.terms = !terms
        setErrors(valid)
        if (!valid.iban && !valid.bic && !valid.cgu && !valid.cgv && !valid.terms) {
            return true
        } else {
            return false
        }
    }
    const getIban = (value: string) => {
        if (value) {
            setIban(value.replace(/\s/g, ''))
        }
    }
    const getBic = (value: string) => {
        if (value) {
            setBic(value.replace(/\s/g, ''))
        }

    }
    useEffect(() => {
        if (params.key) {
            TeachrContactRepository.fetchTeachrContactByKey(params.key).then((response) => {
                if (response) {
                    setTeachrContact(response)
                    setTeachr(response.teachr)
                    if (response.address) {
                        setAddress(response.address)
                    }
                    if (response.iban) {
                        setIban(response.iban)
                    }
                    if (response.bic) {
                        setBic(response.bic)
                    }
                }
            })
                .catch(() => navigate('/notfound'))
        } else {
            navigate('/notfound')
        }
    }, [])
    const nextStep = () => {
        if (validate() && teachrContact) {
            teachrContact.iban = iban
            teachrContact.step = 4
            teachrContact.bic = bic
            teachrContact.acceptMarketingEmail = acceptMarketingEmail
            teachrContact.isNotify = isNotify
            if (address) {
                teachrContact.address = address['@id']!
            }
            if (teachr) {
                teachrContact.teachr = teachr['@id']!
            }
            TeachrContactRepository.updateTeachrContact(teachrContact).then(() => {
                props.nextStep(4)
            }).catch((error) => {
                console.warn(error)
            })
        }

    }
    const prevStep = () => {
        props.nextStep(1)
    }
    const renderScreen = () => {
        if (teachrContact) {
            dispatch({
                type: 'HIDE_LOADER'
            })
            return (
                <Layout teachr={teachr?.firstName} prev={<Button onClick={() => prevStep()} className='w-full py-2 font-extrabold uppercase bg-white border-2 border-solid rounded-full text-first md:text-base px-14 md:w-max border-first'>precedent</Button>} next={<Button onClick={() => nextStep()} className='w-full py-2 text-lg font-extrabold text-white uppercase rounded-full px-14 bg-first md:w-max border-2 border-solid border-first'>SUIVANT</Button>}>
                    <div className="flex flex-col gap-x-8 md:flex-row">
                        <div className='w-full'>
                            <h1 className='pb-2 text-lg font-bold 2xl text- md:text-xl text-first'>Mes informations bancaires</h1>
                            <div className={`${errors.iban || errors.bic ? 'pt-5' : 'pt-0'} flex flex-col gap-y-4 `}>
                                <div className='relative w-full'>
                                    <p className={`${errors.iban ? 'block' : 'hidden'} text-third text-base md:text-base`}>{ValidateIbanAici(iban).message}</p>
                                    <Input callBack={getIban} defaultValue={Functions.addEspacesIBAN(iban)} field='iban' label='IBAN' placeholder='FR00 0000 0000 0000 0000 0000 000' />
                                </div>
                                <div className='relative w-full'>
                                    <p className={`${errors.bic ? 'block' : 'hidden'} text-third text-base md:text-base`}>{ValidateBIC(bic).message}</p>
                                    <Input callBack={getBic} defaultValue={bic} field='bic' label='BIC' placeholder='CBBFRBZJAJHG' />
                                </div>
                            </div>
                        </div>
                        <div className='w-full pt-8 md:pt-0'>
                            <div className="flex items-center gap-x-2">
                                <svg width="38" height="31" viewBox="0 0 38 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_5724_22853)">
                                        <path d="M32.1215 15.2077L27.8515 0.676309C27.7038 0.1732 27.1772 -0.11429 26.6828 0.0359889L0.664567 7.95179C0.170143 8.10207 -0.112385 8.63785 0.0353002 9.14095L4.30532 23.6723C4.45301 24.1754 4.97954 24.4629 5.47396 24.3126L31.4922 16.3968C31.9866 16.2466 32.2692 15.7108 32.1215 15.2077Z" fill="#219CFF" />
                                        <path d="M28.3009 2.1961L0.484375 10.6602L1.43547 13.8966L29.2519 5.43258L28.3009 2.1961Z" fill="#3E5D9E" />
                                        <path d="M32.1215 15.2077L27.8515 0.676309C27.7038 0.1732 27.1772 -0.11429 26.6828 0.0359889L0.664567 7.95179C0.170143 8.10207 -0.112385 8.63785 0.0353002 9.14095L4.30532 23.6723C4.45301 24.1754 4.97954 24.4629 5.47396 24.3126L31.4922 16.3968C31.9866 16.2466 32.2692 15.7108 32.1215 15.2077Z" fill="#219CFF" />
                                        <path d="M28.3009 2.1961L0.484375 10.6602L1.43547 13.8966L29.2519 5.43258L28.3009 2.1961Z" fill="#3E5D9E" />
                                        <path d="M27.4767 31.0019C27.3515 31.0019 27.2295 30.9692 27.1203 30.9104C20.9785 27.6957 17.0713 21.3056 16.9493 14.2817C16.9461 13.233 17.0392 12.1875 17.2286 11.1585C17.3057 10.7436 17.7006 10.4724 18.1083 10.5508C18.1244 10.5541 18.1404 10.5573 18.1565 10.5606C18.9206 10.7599 19.7072 10.8579 20.4969 10.8546C22.8984 10.8677 25.21 9.93989 26.9566 8.26395C27.2487 7.97973 27.711 7.97973 28.0032 8.26395C29.7497 9.93989 32.0613 10.8677 34.4628 10.8546C35.2526 10.8579 36.0392 10.7599 36.8033 10.5606C37.2046 10.4561 37.6156 10.7011 37.7183 11.1095C37.7215 11.1258 37.7247 11.1421 37.7279 11.1585C37.9174 12.1875 38.0105 13.233 38.0073 14.2817C37.8885 21.3088 33.978 27.699 27.8363 30.9104C27.7239 30.9725 27.6019 31.0019 27.4767 31.0019Z" fill="#8CC63F" />
                                        <path d="M26.64 24.313L33.4496 16.2306C33.8413 15.734 33.7642 15.0055 33.2762 14.6069C32.8075 14.2247 32.13 14.2769 31.7255 14.7278L25.8374 21.719L23.2818 18.2528C22.9062 17.7432 22.1934 17.6386 21.6926 18.0208C21.1917 18.4031 21.089 19.1283 21.4646 19.638L24.8678 24.2574C25.0733 24.5384 25.3943 24.7083 25.7379 24.7181C25.7507 24.7181 25.7635 24.7181 25.7764 24.7181C26.1103 24.7181 26.4249 24.5711 26.64 24.313Z" fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_5724_22853">
                                            <rect width="38" height="31" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <h2 className='text-lg font-semibold text-first'>Prélévement sécurisé et opéré par l’URSSAF.</h2>
                            </div>
                            <p className='text-sm text-[rgba(128,128,128,1)] font-semibold py-8'>Les informations bancaires demandées sont strictement confidentielles et seront utilisées uniquement par l’URSSAF</p>
                        </div>

                    </div>
                    <div className="w-full py-4">
                        <p className={`${errors.terms ? 'block' : 'hidden'} text-third text-base md:text-base`}>{errors.terms ? 'Veuillez accepter la politique des données' : ''}</p>
                        <FormControlLabel className='items-start gap-2'
                            onChange={() => setTerms(!terms)}
                            label={<a href='https://www.teachr.fr/policy' className='font-semibold underline text-inherit' target="_blank">J’accepte la politique des données de Teach'r</a>}
                            control={
                                <Checkbox className='p-0 ' />
                            }
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    'fontSize': '14px',
                                    'fontWeight': 600,
                                    'textAlign': 'justify',
                                    'fontFamily': "nunito"
                                }
                            }}
                        />

                    </div>
                    <div className="w-full py-4">
                        <p className={`${errors.cgv ? 'block' : 'hidden'} text-third text-base md:text-base`}>{errors.cgv ? 'Veuillez accepter les  CGUs et CGVs' : ''}</p>
                        <FormControlLabel className='items-start gap-2'
                            onChange={() => setCgv(!cgv)}
                            label={<a href='https://www.teachr.fr/cgu_cgv' className='font-semibold text-inherit underline' target="_blank">J'accepte les CGUs et CGVs</a>}
                            control={
                                <Checkbox className='p-0 ' />
                            }
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    'fontSize': '14px',
                                    'fontWeight': 600,
                                    'textAlign': 'justify',
                                    'fontFamily': "nunito"
                                }
                            }}
                        />

                    </div>
                    <div className="w-full py-4">
                        <p className={`${errors.cgu ? 'block' : 'hidden'} text-third text-base md:text-base`}>{errors.cgu ? "Veuillez accepter les conditions générales d'utilisation pour continuer" : ""}</p>
                        <FormControlLabel className='items-start gap-2'
                            onChange={() => setCgu(!cgu)}
                            label="J'autorise Teach'r à transmettre mes informations à l'URSSAF afin que mon compte soit créé sur la plateforme particulier.urssaf.fr, ce service est mis en place par l’URSSAF et la direction générale des Finances publiques. Vous y avez accès gratuitement et sans obligation d’achat. Ce service n’est pas obligatoire vous pouvez si vous le souhaitez continuer à utiliser le crédit d’impôt sans bénéficier de l’avance immédiate."
                            control={
                                <Checkbox className='p-0 ' />
                            }
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    'fontSize': '14px',
                                    'fontWeight': 600,
                                    'textAlign': 'justify',
                                    'fontFamily': "nunito"
                                }
                            }}
                        />

                    </div>
                    <div className="w-full py-4">
                        <FormControlLabel className='items-start gap-2'
                            onChange={() => setIsNotify(!isNotify)}
                            label="Je souhaite être notifié à chaque fois que mon professeur déclare un cours pour moi"
                            control={
                                <Checkbox className='p-0 ' />
                            }
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    'fontSize': '14px',
                                    'fontWeight': 600,
                                    'textAlign': 'justify',
                                    'fontFamily': "nunito"
                                }
                            }}
                        />

                    </div>
                    <div className="w-full py-4">
                        <FormControlLabel className='items-start gap-2'
                            onChange={() => setAcceptMarketingEmail(!acceptMarketingEmail)}
                            label="J'accepte recevoir des offres promotionnelles de la part de Teach'r."
                            control={
                                <Checkbox className='p-0 ' />
                            }
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    'fontSize': '14px',
                                    'fontWeight': 600,
                                    'textAlign': 'justify',
                                    'fontFamily': "nunito"
                                }
                            }}
                        />

                    </div>
                </Layout>
            )
        }
        dispatch({
            type: 'SHOW_DASHBOARD_AICI_LOADER'
        })
        return  
    }
    return (
        <div className='w-full'>
            {renderScreen()}
        </div>
    );
};

export default Third;